(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('LoadingController', ["$scope", "$modalInstance", "options", function ($scope, $modalInstance, options) {
        $scope.title = options.title;
        $scope.state = 'progress';
        $scope.comment = options.comment;
        $scope.modal = $modalInstance;
        $scope.options = options;
        $scope.defultBtnLabel = options && options.defaultBtnLabel || 'Close';
        $scope.dismiss = function () {
            $modalInstance.dismiss();
        };
        if (options.api && _(options.api).isFunction()) {
            return options.api().then(function (response) {
                $scope.state = 'done';
                if (response && response.data && response.data.status === 'ok' && response.data.message) {
                    $scope.comment = '<div class="loading-comment">' + (response.data.message || 'User verification succeeded') + '<div class="fa fa-check-circle fa-2x green-check"></div></div><br>' + 'Office 365 Onboarding is in progress, Onboarding status can be viewed from either ' + 'SAAS health status or system tasks menu';
                    $scope.hideDefaultBtn = true;
                    $scope.options.buttons = [{
                            label: 'Ok',
                            class: 'btn-success',
                            action: function (modal) {
                                $modalInstance.dismiss();
                            }
                        }];
                } else {
                    $scope.comment = '<div class="loading-comment">User verification failed<div class="fa fa-times-circle fa-2x red-times"></div></div>';
                }
            }, function (error) {
                $scope.state = 'done';
                $scope.comment = '<div class="loading-comment">User verification failed<div class="fa fa-times-circle fa-2x red-times"></div></div>';
            });
        }
    }]);
    m.factory('loadingModal', ["$modal", "path", function ($modal, path) {
        var modalInstance;
        return {
            show: function (options) {
                options = $.extend(true, {}, options);
                modalInstance = $modal.open({
                    templateUrl: path('common').ctrl('loading-modal').template(),
                    controller: 'LoadingController',
                    backdrop: _(options).isObject() && !_(options.backdrop).isUndefined() ? options.backdrop : true,
                    keyboard: false,
                    resolve: { options: _.constant(options) },
                    windowClass: options.windowClass
                });
                return modalInstance.result;
            },
            dismiss: function () {
                if (_(modalInstance).isObject() && _(modalInstance.dismiss).isFunction()) {
                    return modalInstance.dismiss();
                }
            }
        };
    }]);
}());